module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av485-46b90d9bbe9b996adf133c2eb2a7bdda.jpg";